import { Route, RouteProps } from "react-router";

import { StandardPageLayout } from "@/components/layouts/standard-page-layout";

type LayoutRouteProps = RouteProps & {
  component: React.ComponentType<any>;
};

export const LayoutRoute = ({
  component: Component,
  ...rest
}: LayoutRouteProps) => (
  <Route
    {...rest}
    render={(routeProps) => (
      <StandardPageLayout>
        <Component {...routeProps} />
      </StandardPageLayout>
    )}
  />
);
